import React from "react";

import "./TextAlign.css";

export const TextCenter: React.FunctionComponent<React.PropsWithChildren> = ({
	children
}) => <div className="text-align--center">{children}</div>;

export const TextRight: React.FunctionComponent<React.PropsWithChildren> = ({
	children
}) => <div className="text-align--right">{children}</div>;
